import React from "react";
import { Container } from "react-bootstrap";
import { FaFacebookF, FaWhatsapp, FaInstagram, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaTiktok } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "../Style/Footer.css";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <Container>
        <div className="footer-container">
          {/* Logo / About */}
          <div>
            <h3>{t("Stamp Mart")}</h3>
            <p>
              {t("We provide premium quality stamps for collectors and businesses. Trusted by hundreds of happy customers across the United Arab Emirates.")}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3>{t("Quick Links")}</h3>
            <ul>
              <li><a href="#home">{t("Home")}</a></li>
              <li><a href="#about">{t("About Us")}</a></li>
              <li><a href="#products">{t("Our Products")}</a></li>
              <li><a href="#contact">{t("Contact Us")}</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3>{t("Contact Us")}</h3>
            <p><FaPhoneAlt className="me-2" /> +971559139165</p>
            <p><FaEnvelope className="me-2" /> falconstarstamps@gmail.com</p>
            <p>
              <FaMapMarkerAlt className="me-2" /> 
              {t("Al - Sheikh Zayed Bin Sultan St - Hadbat Al Za`Faranah - E26 - Abu Dhabi - UAE")}
            </p>

            {/* Social Icons */}
            <div className="footer-social">
              <a href="https://www.facebook.com/share/165Jd8vRbY/" target="_blank" rel="noreferrer"><FaFacebookF /></a>
              <a href="https://wa.me/+971559139165" target="_blank" rel="noreferrer"><FaWhatsapp /></a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
                <a href="https://www.tiktok.com/@falcon.star.stamp?_t=ZS-8zyFdIlQEmQ&_r=1" target="_blank" rel="noreferrer"><FaTiktok /></a>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div className="footer-bottom">
          <p>
          © {new Date().getFullYear()} {t("Stamp Mart")}. {t("All Rights Reserved.")}<br />
             <small className="developer-credit shine">
              Developed by 
              <strong><a href="https://ehsan-traders-wldx.vercel.app/" target="_blank" rel="noreferrer">Ehsan Traders</a></strong>
            </small>
           </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
